const CLASSES = {
  CARD_EXPANDED: "card-expanded"
};

const SELECTORS = {
  LINK_HEADER: ".card-header a",
  DATA_TARGET: "[data-target]",
  COLLAPSE: ".collapse"
};

class Accordion {

  toggleBodyDisplay(elementIndex) {
    let element = this.accordionsCardsLinks[ elementIndex ];
    let isExpanded = element.getAttribute("aria-expanded") === "true";

    if (isExpanded) {
      element.parentElement.parentElement.classList.remove(CLASSES.CARD_EXPANDED);
    } else {
      if (!element.parentElement.parentElement.classList.contains("multi")) {

        // si l'accordéon n'est pas en mode multi, fermer toutes les lignes
        for (let link of this.accordionsCardsLinks) {
          link.parentElement.parentElement.classList.remove(CLASSES.CARD_EXPANDED);
        }
      }

      // ouvrir la ligne sélectionnée
      element.parentElement.parentElement.classList.add(CLASSES.CARD_EXPANDED);
    }
  }

  /**
   * Retourne une chaîne de caractères préfixée avec #
   * @param {string} string
   * @returns {string}
   */
  addHashTagIfMissing(string) {
    if (!this.findHashTag(string)) {
      return "#" + string;
    }
    return string;
  }

  /**
   * Verifie si un string a un hashtag préfixé au debut
   * @param {string} string
   * @returns {boolean}
   */
  findHashTag(string) {
    return typeof string === "string" && string.indexOf("#") === 0;
  }

  init(container) {
    this.container = container;
    this.accordionsCardsLinks = container.querySelectorAll(SELECTORS.LINK_HEADER);

    this._onClick = (index) => {
      this.toggleBodyDisplay(index);
    };

    this._onClicks = [];
    let collapseList = container.querySelectorAll(SELECTORS.COLLAPSE);

    collapseList.forEach((collapse, index) => {

      // On met un listener pour pouvoir ouvrir ou fermer un bloc de l'accordéon
      // On se base sur l'événement boosted pour gérer correctement le double-clic
      this._onClicks[ index ] = this._onClick.bind(this, index);
      $(collapse).on("show.bs.collapse", this._onClicks[ index ]);
      $(collapse).on("hide.bs.collapse", this._onClicks[ index ]);
    });

    this.accordionsCardsLinks.forEach((linkToSet) => {

        // On met à jour la class card-expanded sur les blocs ouverts de l'accordéon
        let isExpanded = linkToSet.getAttribute("aria-expanded") === "true";
        if (isExpanded) {
          linkToSet.parentElement.parentElement.classList.add(CLASSES.CARD_EXPANDED);
        }
      }
    );

    const dataTargetList = container.querySelectorAll(SELECTORS.DATA_TARGET);
    dataTargetList.forEach((dataTarget) => {

      // Assure la rétrocompatibilité
      // Les valeurs de data-target doivent commencer par un # (comme dans boosted) alors on l'ajoute si absent
      dataTarget.dataset.target = this.addHashTagIfMissing(dataTarget.dataset.target);
    });
  }

  constructor(container) {
    if (container) {
      if (typeof container.dataset.ref === "undefined") {
        this.ref = Math.random();
        Accordion.refs[ this.ref ] = this;
        container.dataset.ref = this.ref.toString();
        this.init(container);
      } else {

        // If this element has already been instantiated, use the existing reference.
        return Accordion.refs[ container.dataset.ref ];
      }
    }
  }

  /**
   * Décharge le composant
   */
  dispose() {

    // suppression de tous les event listeners qui ont été créés
    this.accordionsCardsLinks = this.container.querySelectorAll(SELECTORS.LINK_HEADER);
    this.accordionsCardsLinks.forEach((linkToSet, i) => {
      linkToSet.removeEventListener("click", this._onClicks[ i ]);
    });
  }
}

Accordion.refs = {};

document.addEventListener("DOMContentLoaded", () => {
  let accordions = document.querySelectorAll(".accordion");
  [].forEach.call(accordions, (accordion) => {
    new Accordion(accordion);
  });
});

// rattachement au contexte window pour pouvoir l'utiliser en dehors du JS
window.Accordion = Accordion;

export default Accordion;
